import * as BizCharts from 'bizcharts';
import React, { FC } from 'react';
import './chartTheme';
import { withNiceScale } from './chartUtils';

const { Chart, Axis, Geom, Tooltip, Annotation } = BizCharts;

interface LineChartProps {
	cols: any;
	height: number;
	data: any;
	fillArea: boolean;
	position: string;
	chartPadding?: [number, number, number, number];
	color?: string;
	color2?: string;
	xAxisName: string;
	yAxisName: string;
	xAxisLabel?: any;
	yAxisLabel?: any;
	tooltipTemplate?: any;
	baselineValue: number;
	baselineText: string;
}

export const KPILineChart: FC<LineChartProps> = ({
	chartPadding,
	tooltipTemplate,
	baselineValue,
	baselineText,
	data,
	cols,
	color,
	color2,
	height,
	fillArea,
	xAxisName,
	yAxisName,
	xAxisLabel,
	yAxisLabel,
	position,
}) => {
	return (
		<Chart
			height={height}
			padding="auto"
			data={data}
			scale={withNiceScale(cols)}
			autoFit={true}
			theme="openwrench"
		>
			<Axis name={xAxisName} label={xAxisLabel} />
			<Axis name={yAxisName} label={yAxisLabel} />
			<Tooltip
				crosshairs={{ type: 'y' }}
				itemTpl={
					tooltipTemplate
						? tooltipTemplate
						: `
                    <li data-index={index}>
                        <!-- The marker for each record -->
                        <span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>
                        {name}: {value}
                    </li>
                `
				}
			/>
			<Geom type="line" position={position} color={color} size={2} />
			{fillArea ? <Geom type="area" position={position} color={color} /> : null}
			<Geom
				type="point"
				position={position}
				color={color}
				size={4}
				shape={'circle'}
				style={{ stroke: '#fff', lineWidth: 1 }}
			/>
			<Annotation.RegionFilter
				top={true}
				start={['min', baselineValue]}
				end={['max', 'min']}
				color={color2 || '#FF4D4F'}
			/>
			<Annotation.RegionFilter
				top={true}
				start={['min', 'max']}
				end={['max', baselineValue]}
				color={color || '#18a1cd'}
			/>
		</Chart>
	);
};
